import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useHeaderStore } from 'src/store';

import { engLettersArr, FilterTrigger, ruLettersArr } from '../consts';
import { isEngLetter, isRuLetter } from '../helper';
import FilterButton from './FilterButton';
import styles from './LetterListMobile.module.scss';
import Sticky from './Sticky';

const LetterListMobile = ({ firstLettersArr }: { firstLettersArr: string[] }) => {
    const { query } = useRouter();
    const isFixed = useHeaderStore(({ isFixed }) => isFixed);
    const FilterTriggers = useMemo(() => Object.values(FilterTrigger), []);
    const filterLetter = useMemo(() => (query?.filter as string) || FilterTrigger.Default, [query?.filter]);
    const arrLetters = useMemo(
        () =>
            filterLetter === FilterTrigger.EngAlphabet || isEngLetter(filterLetter)
                ? engLettersArr
                : filterLetter === FilterTrigger.RuAlphabet || isRuLetter(filterLetter)
                  ? ruLettersArr
                  : null,
        [filterLetter]
    );

    return (
        <div>
            <div className={styles.titleRow}>
                <h2 className={styles.title}>Бренды</h2>
            </div>
            <Sticky>
                <div className={styles.panel}>
                    <div className={styles.triggers}>
                        {FilterTriggers.map((value, i) => {
                            if (i === 0) return null;

                            return <FilterButton buttonText={value} key={value} isSticky={isFixed} />;
                        })}
                    </div>
                    <div className={styles.letters}>
                        {arrLetters?.map(letter => (
                            <FilterButton
                                buttonText={letter.toUpperCase()}
                                isSticky={isFixed}
                                key={letter}
                                available={firstLettersArr.includes(letter.toLowerCase())}
                            />
                        ))}
                    </div>
                </div>
            </Sticky>
        </div>
    );
};

export default LetterListMobile;
